import { render, staticRenderFns } from "./CompanyRegister.vue?vue&type=template&id=49854c91&"
import script from "./CompanyRegister.vue?vue&type=script&lang=js&"
export * from "./CompanyRegister.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports